import React from 'react'
import { SkBtnCircle } from '@core/components/btns'
import { SkBtnCircleProps } from '@core/components/btns/skBtnCircle'
import { SkIconUilPlus } from '@core/global/icons'

export function SkBtnCircleAdd(props: SkBtnCircleProps) {
  return <SkBtnCircle icon={<SkIconUilPlus />} tooltip="Ajouter" {...props} />
}
